let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("38sfA")).then(() => parcelRequire('css4w'));